//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount';

export default {
  name: 'FreeExplore',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  computed: {
    freeVideoCount() {
      return renderContentCount(this, publishedContentCounts.total.free.video);
    },
  },
};
